export default __webpack_public_path__ + "static/media/logo-lantern.7e8647b0.png";